import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeQuote = () => {
  const [QuoteUser, setQuoteUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getQuote");
      setQuoteUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteQuote/${userId}`);

      setQuoteUser(
        (prevUsers) => prevUsers.filter((user) => user.id !== userId) 
      );

      toast.error("Data Deleted Successfully!");
      navigate("/Quote");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {/* <Link to="/Quote-add">
            <button className="Banner-button">Add</button>
          </Link> */}

          {QuoteUser.map((user) => {
            
            return (
              <div key={user.id}>
                {" "}
                <h3>
                  {user.heading}{" "}
                  <Link to={`/Quote-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                  {/* <span onClick={() => deleteUser(user.id)}>
                    {" "}
                    <i
                      title="Delete"
                      className="fa-solid fa-trash-can action-sec"
                      style={{ color: "red" }}
                    ></i>
                  </span> */}
                </h3>
                <p dangerouslySetInnerHTML={{ __html: user.para }}></p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export const HomeQuoteEdit = () => {
  const [Quoteuser, setQuoteUser] = useState({
    heading: "",
    para: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // ✅ Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setQuoteUser({ ...Quoteuser, [name]: value });
  };

  // ✅ Load CKEditor script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) => {
          window.CKEDITOR.instances[instance].destroy(true);
        });
      }
    };
  }, []);

  // ✅ Fetch Quote data
  const fetchQuoteData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getoneQuote/${id}`
      );
      if (response.data.success) {
        setQuoteUser(response.data.data);

        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.para
          );
        }
      }
    } catch (error) {
      console.error("Error fetching Quote data!", error);
      toast.error("Failed to load Quote data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) {
      fetchQuoteData();
    }
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Quoteuser.para || "");
    }
  }, [Quoteuser.para, editorLoaded]);

  // ✅ Submit form data
  const submitForm = async (e) => {
    e.preventDefault();

    const updatedData = {
      heading: Quoteuser.heading,
      para: window.CKEDITOR.instances.editor.getData(),
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateQuote/${id}`,
        updatedData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        toast.success("Quote updated successfully!");
        navigate("/Quote");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error updating the Quote!", error);
      toast.error("Failed to update Quote.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Quote">
                <button
                  type="button"
                  className="close"
                >
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Quoteuser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                  required
                />
                <br/>
              </div>

              <div className="form-group">
                <label>para</label>
                <textarea id="editor"></textarea>
                <br/>
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Quote">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const QuoteAdd = () => {
  const [QuoteData, setQuoteData] = useState({
    heading: "",
    para: "",
  });

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setQuoteData((prev) => ({ ...prev, [name]: value }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!QuoteData.heading || !QuoteData.para) {
      toast.error("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(
        "https://admin.gosaviadvanceddentalclinic.com/api/createQuote",
        QuoteData
      );
      toast.success("Data added successfully!");
      navigate("/Quote"); 
    } catch (error) {
      console.error("Error adding Quote:", error);
      toast.error("Failed to add Quote!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12"/>
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
      <div className="add-banner">
        <Link to="/Quote"> <i className="fa-solid fa-xmark"></i></Link>
        <h3>Add Quote Data</h3>
        <form className="row" onSubmit={submitForm}>
          <div className="col-lg-12 col-md-12 col-sm-12 inputform">
            <label htmlFor="heading">Heading</label>
            <input
              type="text"
              onChange={inputHandler}
              value={QuoteData.heading}
              id="heading"
              name="heading"
              placeholder="Enter Heading"
            />
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 inputform">
            <label htmlFor="para">Description</label>
            <textarea
              onChange={inputHandler}
              value={QuoteData.para}
              id="para"
              name="para"
              placeholder="Enter Description"
              rows="4"
            ></textarea>
          </div>
          <div className="mobilesubmitform">
            <button type="submit">Add Data</button>
          </div>
        </form>
      </div>
      </div>
      </div>
    </div>
  );
};


